import { Typography, TypographyProps } from "@mui/material";
import * as React from "react";

type FeedVariants =
    | "body1"
    | "body2"
    | "body3"
    | "classification"
    | "title"
    | "largeTitle"
    | "authorPrimary"
    | "authorSecondary"
    | "authorCaption"
    | "content"
    | "taskHeader"
    | "taskContent"
    | "action"
    | "moreContent"
    | "sticker"
    | "stickerLowercase"
    ;

interface IProps {
    variant: FeedVariants;
    component?: React.ElementType;
    color?: MprcColorsExtended | [MprcColors, MprcColorVariant];
}

type Props = IProps & Omit<TypographyProps, "variant" | "color">;

export const MprcFeedTypography: React.FC<Props> = (props) => {
    const { children, variant, component, color, ...rest } = props;
    return (
        <Typography
            variant="inherit"
            component={component || "span"}
            {...rest}
            sx={
                (theme) => {
                    var c = color == undefined
                        ? {}
                        : Array.isArray(color)
                            ? { color: theme.palette[color[0]][color[1]] }
                            : color == "white"
                                ? { color: theme.palette.common.white }
                                : color == "black"
                                    ? { color: theme.palette.common.black }
                                    : color == "inherit"
                                        ? { color: "inherit" }
                                        : color == "transparent"
                                            ? { color: "transparent" }
                                            : { color: theme.palette[color!].main };

                    return ({
                        ...theme.extended.feed[variant],
                        ...c
                    });
                }
            }
        >
            {children}
        </Typography>
    );
};
